export default "__VITE_ASSET__DlSKcuUj__"